import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const routeLabels = {
  dashboard: 'Dashboard',
  connections: 'Connections',
  people: 'Connections',
  activity: 'Activity',
  projects: 'Projects',
  invoices: 'Invoices',
  contracts: 'Contracts',
  files: 'Files',
  payments: 'Payments',
  clients: 'Clients',
  calendar: 'Calendar',
  notifications: 'Notifications',
  settings: 'Settings',
  spectre: 'Specter',
  analytics: 'Analytics',
};

export default function Breadcrumbs({ projectName }) {
  const location = useLocation();
  const parts = location.pathname.split('/').filter(Boolean);

  const crumbs = [{ label: 'Slate', path: '/dashboard' }];

  parts.forEach((part, i) => {
    const path = '/' + parts.slice(0, i + 1).join('/');
    if (routeLabels[part]) {
      crumbs.push({ label: routeLabels[part], path });
    } else if (i > 0 && parts[i - 1] === 'projects') {
      crumbs.push({ label: projectName || part, path });
    }
  });

  if (crumbs.length <= 1) return null;

  return (
    <nav className="flex items-center gap-1 text-[13px] mb-6" data-testid="breadcrumbs">
      {crumbs.map((crumb, i) => {
        const isLast = i === crumbs.length - 1;
        return (
          <span key={crumb.path} className="flex items-center gap-1">
            {i > 0 && <ChevronRight className="w-3 h-3 text-muted-foreground/40" strokeWidth={1.5} />}
            {isLast ? (
              <span className="text-foreground font-medium" data-testid="breadcrumb-current">{crumb.label}</span>
            ) : (
              <Link to={crumb.path} className="text-muted-foreground hover:text-foreground transition-colors" data-testid={`breadcrumb-${crumb.label.toLowerCase()}`}>
                {crumb.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
